export default __webpack_public_path__ + "static/media/146.0bed9d48.png";